module.exports = __webpack_public_path__ + "img/pagelogo.a57859eb.png";